
<script>
import Utils from '../mixins/ObjectUtilsMixin';
import { Line } from 'vue-chartjs';

export default {
    extends: Line,

    mixins: [
        Utils,
    ],

    props: {
        config: {
            type: Object,
            default: () => {
                return {
                    chart: null,
                };
            },
        },
        chartData: {
            type: Array,
            default: () => [],
        },

        exportWatch: {
         type: Number,
         default: 1,   
        }
    },

    data() {
        return {
            renderedData: {},
            chartOptions: {
                type: 'line',
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    xAxes: [{
                        type: 'time',
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'Date',
                        },
                        time: {
                            tooltipFormat: 'DD MMM YYYY',
                        },
                    }],
                    yAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'Data',
                        },
                    }],
                },
            },
            colors: [
                'rgba(184, 207, 138, 0.5)',
                'rgba(119, 147, 60, 0.5)',
                'rgba(255, 255, 0, 0.5)',
                'rgba(228, 108, 10, 0.5)',
                'rgba(204, 204, 204, 0.5)',
                'rgba(255, 0, 0, 0.5)',
                'rgba(0, 0, 0, 0.5)',
            ],
        };
    },

    mounted() {
        // merge user-supplied and default chart config
        this.objectMerge(this.chartOptions, this.config.chart);

        if (this.chartData) {
            this.render();
            return;
        }

        // emergency routine for no data?
    },

    watch: {
        // get and render everytime queryParams change
        chartData() {
            this.render();
        },
    },

    methods: {
        prepareData() {
            if (Array.isArray(this.chartData) && this.chartData.length > 0) {
                let datasets = this.chartData.map((dataSet, i) => {
                    return {
                        data: dataSet.data.sort((a, b) => a.x >= b.x ? 1 : -1),
                        label: dataSet.label,
                        meta: dataSet.meta,
                        fill: false,
                        tension: 0,
                        backgroundColor: this.colors[i % this.colors.length],
                        borderColor: this.colors[i % this.colors.length],
                    };
                });

                this.renderedData = {
                    datasets,
                };
            }
        },

        render() {
            this.prepareData();
            this.renderChart(this.renderedData, this.chartOptions);
        },

        exportToImg()
        {
            // Add the link to DOM
            let downloadLink = document.createElement('a');
            document.body.appendChild(downloadLink);
            downloadLink.style.display = 'none';

            // set image to download link
            downloadLink.setAttribute('download', 'chart.png');
            downloadLink.setAttribute('href', this.$refs.canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream'));
            
            // click and remove the download link
            downloadLink.click();
            downloadLink.parentNode.removeChild(downloadLink);

        },

    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/charts/TimeseriesChartComponent.vue